import SocialSection from './SocialSection.js';

export default SocialSection;
